//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'ACCR',
  data () {
    return {
      form: {
        urineamylase: '',
        bloodamylase: '',
        ucr: '',
        scr: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: '1', name: '无需手术' },
        { value: '2', name: '择期手术' },
        { value: '5', name: '急诊手术' }
      ],
      dataList2: [
        { value: '0', name: '<50%' },
        { value: '1', name: '≥50%' }
      ],
      logit: '...'
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }

      if (!flag) {
        self.hasScore = false
        self.logit = '...'
        return '...'
      } else {
        console.log(form)
        let result = (form.urineamylase / form.bloodamylase) / (form.ucr / form.scr)

        self.hasScore = true
        return String(result.toFixed(1))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GIT/ACCR.vue